import PropTypes from "prop-types";
import styles from "./CategoryHeader.css";
import CategoryDescription from "./CategoryDescription";
import { CATEGORY_BANNER_ID } from "../../components/constants";
import {
  isSeoFriendly,
  removeSeoFlagDecoded
} from "../../../src/state/modules/category/helpers.js";
import logger from "../../lib/logger";

const getHeaderText = (headerTitle, headerHtml, friendlyName, cid) => {
  if (headerTitle) {
    return headerTitle;
  } else if (isSeoFriendly(headerHtml, false)) {
    return removeSeoFlagDecoded(headerHtml);
  } else {
    if (SERVER) {
      logger.warn("CategoryHeaderFallback", {
        message: "Category Header Fallback Text displayed",
        level: "warn",
        friendlyName,
        cid,
        type: "CategoryHeaderFallback"
      });
    }

    return friendlyName;
  }
};

export const CategoryHeader = ({
  category: { headerTitle, headerHtmlEncoded, friendlyName, id }
}) => (
  /*
   * The headerHtmlEncode logic (as per story WD-6031) is to be used until
   * migration to sitecore 8 and seofriendly name has its own key
   * in the categoryDetails object.
   */
  <section id={CATEGORY_BANNER_ID} className={styles.wrapper}>
    <div className={styles.textWrapper}>
      <h1 className={styles.categoryTitle}>
        {getHeaderText(headerTitle, headerHtmlEncoded, friendlyName, id)}
      </h1>
      <CategoryDescription />
    </div>
  </section>
);

CategoryHeader.propTypes = {
  category: PropTypes.shape({
    headerTitle: PropTypes.string,
    headerHtmlEncoded: PropTypes.string.isRequired,
    friendlyName: PropTypes.string.isRequired,
    id: PropTypes.number
  }).isRequired
};

export default CategoryHeader;
